const CLIENT = {
    baseUrl: 'https://api.joeeventos.com'
}

export {
    CLIENT
}